import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/legal-document-storage-for-law-firms.jpg'),
    alt: 'legal document storage for law firms page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'legal document storage for law firms page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Legal <span>Document</span><span>Storage Solutions For Law Firms</span>',
  description:
    'Ensure the safety, organization, and accessibility of your legal documents with our specialized storage solutions tailored for law firms. Protect sensitive client information while streamlining document retrieval and maintaining compliance with legal requirements.',
  image: {
    url: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/hero-image.jpg',
    alt: 'Legal Document Storage Solutions For Law Firms'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Legal Document Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Our Legal Document Storage for Law Firms Works',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/how-our-legal-document-storage-for-law-firms-works.png',
    alt: 'How Our Legal Document Storage for Law Firms Works'
  },

  articles: [
    {
      id: 1,
      title: 'Customizable Storage Solutions',
      description:
        'We offer flexible storage options designed to meet the unique needs of law firms, with secure categorization and easy access.',
      image: {
        src: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/customizable-storage-solutions.png',
        alt: 'Customizable Storage Solutions'
      }
    },
    {
      id: 2,
      title: 'Secure, Monitored Facilities',
      description:
        'Your documents are stored in state-of-the-art facilities with 24/7 surveillance, restricted access, and fire-resistant units for maximum protection.',
      image: {
        src: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/secure-monitored-facilities.png',
        alt: 'Secure, Monitored Facilities'
      }
    },
    {
      id: 3,
      title: 'Efficient Retrieval System',
      description:
        'Retrieve your legal documents quickly and securely whenever you need them with our streamlined access system.',
      image: {
        src: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/efficient-retrieval-system.png',
        alt: 'Efficient Retrieval System'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Legal Document Storage Services For Firms',
  description:
    'Our legal document storage services provide law firms with a secure and compliant environment for sensitive records. We ensure your documents are well-organized and easily accessible, helping you maintain confidentiality and improving operational efficiency. Trust us to protect your valuable legal information, allowing you to focus on serving your clients.',
  image: {
    src: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/legal-document-storage-services-for-firms.jpg',
    alt: 'Legal Document Storage Services For Firms'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Legal Document Storage for Law Firms',

  cards: [
    {
      id: 1,
      title: 'Confidentiality and Security',
      description:
        'All legal documents are stored with the highest level of security, ensuring confidentiality and preventing unauthorized access.',
      image: {
        src: '/images/v2/pages/common/secure-and-reliable.png',
        alt: 'Confidentiality and Security'
      }
    },
    {
      id: 2,
      title: 'Space Optimization',
      description: 'Free up valuable office space by storing your legal documents in secure offsite facilities.',
      image: {
        src: '/images/v2/pages/common/free-up-office-space.png',
        alt: 'Space Optimization'
      }
    },
    {
      id: 3,
      title: 'Regulatory Compliance',
      description:
        'Ensure that your firm meets legal retention requirements and complies with industry regulations for document storage.',
      image: {
        src: '/images/v2/pages/common/improved-compliance.png',
        alt: 'Regulatory Compliance'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Legal Document Storage for Law Firms?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Solo Practitioners',
          description:
            'Organize and secure your legal documents without the need for costly physical storage in your office.'
        },
        {
          id: 2,
          title: 'Small to Medium Law Firms',
          description: 'Store large volumes of client files and case documents securely and in an organized manner.'
        },
        {
          id: 3,
          title: 'Large Law Firms',
          description:
            'Manage a vast array of legal documents across departments while ensuring efficient access and security.'
        },
        {
          id: 4,
          title: 'Corporate Law Departments',
          description:
            'Safeguard business and client legal records, ensuring they remain compliant and accessible when needed.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/who-should-use-legal-document-storage-for-law-firms.jpg',
        alt: 'Who Should Use Legal Document Storage for Law Firms?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Legal Document Storage Services',

  cards: [
    {
      id: 1,
      title: 'Short-Term Legal Document Storage',
      description: 'Store documents temporarily for cases or projects with flexible duration options.',
      image: {
        src: '/images/v2/pages/common/short-term-document-storage.png',
        alt: 'Short-Term Legal Document Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Document Shredding Services',
      description:
        'When documents reach the end of their retention period, we provide secure shredding to ensure the complete destruction of sensitive files.',
      image: {
        src: '/images/v2/pages/common/secure-shredding-services.png',
        alt: 'Document Shredding Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Long-Term Archival Legal Storage',
      description: 'Preserve legal records for extended periods while ensuring compliance with retention policies.',
      image: {
        src: '/images/v2/pages/common/long-term-archival-storage.png',
        alt: 'Long-Term Archival Legal Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Digital Document Conversion',
      description:
        'Convert paper files into digital format for easy storage, retrieval, and sharing, helping to reduce paper waste.',
      image: {
        src: '/images/v2/pages/common/digital-document-conversion2.png',
        alt: 'Digital Document Conversion'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Legal Document Storage for Law Firms?',

  image: {
    url: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/why-choose-us-for-legal-document-storage-for-law-firms.jpg',
    alt: 'Why Choose Us for Legal Document Storage for Law Firms?'
  },

  articles: [
    {
      id: 1,
      title: 'Security and Confidentiality',
      description: 'All documents are stored in highly secure, monitored facilities, ensuring their confidentiality.'
    },
    {
      id: 2,
      title: 'Cost-Effective Solutions',
      description: 'Affordable pricing plans tailored to the needs of law firms, no matter the size.'
    },
    {
      id: 3,
      title: 'Compliance with Legal Regulations',
      description:
        'We ensure your documents comply with the strict retention and storage requirements set by legal authorities.'
    },
    {
      id: 4,
      title: 'Customizable Storage Options',
      description:
        'Choose storage plans that align with the specific needs of your firm, whether you need short-term or long-term solutions.'
    },
    {
      id: 5,
      title: 'Easy and Secure Access',
      description: 'Retrieve your legal documents swiftly and securely with our easy-to-use access system.'
    },
    {
      id: 6,
      title: 'Dedicated Support',
      description:
        'Our team provides personalized support to help you optimize your document management system and ensure smooth operations.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Legal Document Storage Services For Law Firms Available',
  description:
    'Legal document storage services available for law firms. Secure, reliable, and affordable solutions for storing legal documents.',
  image: {
    src: '/images/v2/pages/landing-pages/legal-document-storage-for-law-firms/legal-document-storage-services-for-law-firms-available.png',
    alt: 'Legal Document Storage Services For Law Firms Available'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Secure Document Storage' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Document Storage Partners',
  description:
    'We partner with leading carriers to provide law firms with reliable document storage and retrieval services.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers secure logistics and delivery solutions for the storage and transportation of legal documents.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides secure storage and transport services tailored to meet the needs of law firms and legal departments.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS ensures the secure storage and delivery of legal documents with their trusted services.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
